// extracted by mini-css-extract-plugin
export var danger = "_21-6";
export var lightPink = "_21-a";
export var medium = "_21-j";
export var nearSquare = "_21-m";
export var neutralBlue = "_21-8";
export var neutralYellow = "_21-7";
export var noCapitalize = "_21-1";
export var normal = "_21-2";
export var pill = "_21-0";
export var primary = "_21-3";
export var primaryLight = "_21-4";
export var shadow = "_21-n";
export var small = "_21-k";
export var solidBlack = "_21-i";
export var solidGreen = "_21-d";
export var solidLightBlue = "_21-f";
export var solidNavy = "_21-e";
export var solidOrange = "_21-h";
export var solidPink = "_21-g";
export var solidRed = "_21-b";
export var solidWhite = "_21-9";
export var solidYellow = "_21-c";
export var success = "_21-5";
export var xsmall = "_21-l";